import request from '@/utils/request'

// 老虎机权重配置修改-列表
export function getSlotWeightCfgList(query) {
  return request({
    url: '/api/v1/slot/slotWeightCfg',
    method: 'get',
    params: query
  })
}

export function getSlotEventCfgList(query) {
  return request({
    url: '/api/v1/slot/slotEventCfg',
    method: 'get',
    params: query
  })
}

export function getSlotEventCfgTempLateList(query) {
  return request({
    url: '/api/v1/slot/slotEventCfgTemplate',
    method: 'get',
    params: query
  })
}

// 老虎机权重配置修改-更新
export function updateSlotWeightCfg(data) {
  return request({
    url: 'api/v1/slot/updateSlotWeightCfg',
    method: 'post',
    data: data
  })
}

export function saveSlotWeightCfgTemp(data) {
  return request({
    url: 'api/v1/slot/saveSlotWeightCfgTemp',
    method: 'post',
    data: data
  })
}

export function updateSlotEventCfg(data) {
  return request({
    url: 'api/v1/slot/updateSlotEventCfg',
    method: 'post',
    data: data
  })
}

// 老虎机权重配置修改-概率导出
export function exportSlotWeightCfg() {
  return request({
    url: 'api/v1/slot/exportProbData',
    method: 'get'
  })
}

// 老虎机权重配置修改-金币导出
export function exportSlotWeightCfgMoney() {
  return request({
    url: 'api/v1/slot/exportMoneyData',
    method: 'get'
  })
}

export function getRewardType(data) {
  return request({
    url: 'api/v1/slot/getRewardType',
    method: 'post',
    data: data
  })
}

export function getChessBoardType() {
  return request({
    url: 'api/v1/slot/getChessBoardType',
    method: 'get'
  })
}

export function importSlotWeightCfg(data) {
  return request({
    url: 'api/v1/slot/importData',
    method: 'post',
    data: data
  })
}

export function importSlotWeightEventCfg(data) {
  return request({
    url: 'api/v1/slot/importEventData',
    method: 'post',
    data: data,
    timeout: 100000
  })
}

export function exportSlotWeightEventCfg(data) {
  return request({
    url: 'api/v1/slot/exportEventData',
    method: 'post',
    data: data
  })
}

// 老虎机权重修正配置
export function getSlotWeightChangeCfg(data) {
  return request({
    url: 'api/v1/slot/slotWeightChangeCfg',
    method: 'post',
    data: data
  })
}

export function getSpinsReturnStatus() {
  return request({
    url: 'api/v1/slot/getSpinsReturnStatus',
    method: 'get'
  })
}

export function changeSpinsReturnStatus(data) {
  return request({
    url: 'api/v1/slot/changeSpinsReturnStatus',
    method: 'post',
    data: data
  })
}

export function updateSlotWeightChangeCfg(data) {
  return request({
    url: 'api/v1/slot/updateWeightChangeCfg',
    method: 'post',
    data: data
  })
}

export function exportSlotWeightChangeCfg(data) {
  return request({
    url: 'api/v1/slot/exportChangeCfgData',
    method: 'post',
    data: data
  })
}

export function importSlotWeightChangeCfg(data) {
  return request({
    url: 'api/v1/slot/importChangeCfgData',
    method: 'post',
    data: data
  })
}

export function getDiceCfg(data) {
  return request({
    url: 'api/v1/slot/getDiceCfg',
    method: 'post',
    data: data
  })
}

export function updateDiceCfg(data) {
  return request({
    url: 'api/v1/slot/updateDiceCfg',
    method: 'post',
    data: data
  })
}

export function deleteDiceCfg(data) {
  return request({
    url: 'api/v1/slot/deleteDiceCfg',
    method: 'delete',
    data: data
  })
}

export function exportDiceCfg() {
  return request({
    url: 'api/v1/slot/exportDiceCfg',
    method: 'get'
  })
}

export function importDiceCfg(data) {
  return request({
    url: 'api/v1/slot/importDiceCfg',
    method: 'post',
    data: data
  })
}
